// The sets a DJ should see: Quickbase's Active ones they haven't rejected. The API
// already asks Quickbase for Active sets only; this also covers a set rejected since
// (Quickbase marks it inactive) and a set rejected on this page before any reload.
export const isShownAssignment = (assignment) =>
  assignment?.active !== false && !assignment?.dj_rejected_shift;

export const shownAssignments = (assignments) => (assignments || []).filter(isShownAssignment);
